import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import AppLayout from '../../../../layout/components/AppLayout'
import TaskForm from '../components/TaskForm'
import TaskGroup from '../components/TaskGroup';
import taskServices from '../taskServices';
import { CalendarMonth } from '@mui/icons-material';

function TaskDashnoardPage() {

    const masterList = ['client','priority','project','task-status'];
    const [masters,getMasterLabel] = useSystemMasterList(masterList);

    const [loading,setLoadingStatus] = useState(false);
    const [taskList,setTaskList] = useState(null);

    const [group,setGroup] = useState("client");

    const getByGroup = () => {
        setLoadingStatus(true);
        taskServices.getByGroup(group).then(res=>{
            setTaskList(res.data);
        }).catch(error=>{

        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getByGroup()
    },[group])
    return (
        <AppLayout>
            <div className="container-fluid">
                <div class="row">
                    <div className="col-md-3">
                        <div class="list-group">
                            {/*
                            <a href="#" class="list-group-item list-group-item-action active" aria-current="true">
                                The current link item
                            </a>
                            */}
                            {masterList.map(master=>
                                <li onClick={()=>setGroup(master)} className={master === group? "list-group-item bg-success text-white": "list-group-item text-white bg-dark"}>{master.toLocaleUpperCase()}</li>
                            )}
                            <li onClick={()=>setGroup("deadline")} className={"deadline" === group? "list-group-item bg-success text-white": "list-group-item text-white bg-dark"}>DEADLINE</li>
                            <li className={"list-group-item bg-dark"}>
                                <div className="text-center">
                                    <TaskForm masters={masters} onSuccess={getByGroup} />
                                </div>
                            </li>
                            <li className={"list-group-item bg-dark"}>
                                <Link className="btn btn-danger" to={"/task/archived"}>Archived List</Link>
                                <Link className="btn btn-outline-warning ms-3" to={"/task/calendar"}><CalendarMonth/> Show Calendar</Link>
                            </li>
                        </div>
                    </div>
                    <div className="col-md-8">
                                {loading && <CircularProgress/>}
                                <div className="row">
                                {!loading && taskList && taskList.map((taskGroup)=>{
                                    if(taskGroup.taskList.length > 0)
                                    return (
                                        <div className="col-md-4" key={taskList.id}>
                                            <TaskGroup  taskGroup={taskGroup} masters={masters} getMasterLabel={getMasterLabel} onSuccess={getByGroup} />
                                        </div>
                                    )
                                })}
                                </div>
                            
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default TaskDashnoardPage